import { Card, Modal } from 'antd';
import { useMemo } from 'react';
import { useStoreActions } from '../../../store';
import { OriginSelectTable } from '../../fulfillmentContext/shared/OriginSelectTable';

export interface OriginSelectModalProps {
  open?: boolean;
  onSelectedOriginsChange: (o: Record<string, boolean>) => void;
  selectedOrigins: Record<string, boolean>;
}
export const ORIGIN_SELECT_MODAL_KEY = 'origin-select-modal-key';
export const OriginSelectModal = ({ open, onSelectedOriginsChange, selectedOrigins }: OriginSelectModalProps) => {
  const toggleModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const selectedOriginIds = useMemo(() => {
    return Object.entries(selectedOrigins).reduce((prev: string[], e) => {
      const [k, v] = e;
      return v ? [...prev, k] : prev;
    }, []);
  }, [selectedOrigins]);
  return (
    <Modal
      width={900}
      open={open}
      closable={false}
      onOk={() => {
        toggleModal({ open: false, key: ORIGIN_SELECT_MODAL_KEY });
      }}
      onCancel={() => {
        toggleModal({ open: false, key: ORIGIN_SELECT_MODAL_KEY });
        onSelectedOriginsChange({});
      }}
    >
      <Card title="Select Origins">
        {selectedOriginIds?.length ?? 0} origins selected
        <OriginSelectTable
          selectedOriginIds={selectedOriginIds}
          allowMultiple={true}
          onSelectedOriginChange={(val) => {
            onSelectedOriginsChange({
              ...selectedOrigins,
              [val]: !selectedOrigins[val],
            });
          }}
        />
      </Card>
    </Modal>
  );
};
